import React from 'react'
import { FieldComponent } from 'components/Shared/FieldComponent'
import styles from './DestinationForm.module.css'
import CompanyAutocompleteField from './CompanyAutocompleteField'
import { DatePickerFormFieldInline } from 'components/Shared/DatePickerInline'
import { useField } from 'formik'
import { ContainerColumn } from '../ContainerColumn'
import { ContainerRow } from '../ContainerRow'
import { CountrySelectField } from 'components/Shared/CountrySelectField/CountrySelectField'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { momentToISOLocalDate } from '../../../../../../../../utils/date'

const useStyles = makeStyles({
  customHelperTextStyles: {
    '& .MuiFormHelperText-contained': {
      marginRight: '-42px',
      display: 'block'
    }
  },
})

export function DestinationForm ({ name, disabled }) {
  const [, { value }, { setValue }] = useField(name)
  const classes = useStyles()

  function handleCompanySelected (addr) {
    setValue({
      ...value,
      ...addr
    })
  }


  function handleFromDateSelected (newFromDate) {
    const { fromDate, toDate } = value
    const fromMoment = moment(fromDate)
    const toMoment = moment(toDate)
    const newFromMoment = moment(newFromDate)
    const newDaysDiff = toMoment.diff(newFromMoment, 'days')
    if (newDaysDiff < 0) {
      const daysDiff = toMoment.diff(fromMoment, 'days')
      const newToMoment = newFromMoment.clone().add(daysDiff, 'days')
      setValue({
        ...value,
        fromDate: newFromDate,
        toDate: momentToISOLocalDate(newToMoment)
      })
    }
  }

  function handleToDateSelected (newToDate) {
    const { fromDate, toDate } = value
    const fromMoment = moment(fromDate)
    const toMoment = moment(toDate)
    const newToMoment = moment(newToDate)
    const newDaysDiff = newToMoment.diff(fromMoment, 'days')
    if (newDaysDiff < 0) {
      const daysDiff = toMoment.diff(fromMoment, 'days')
      const newFromMoment = newToMoment.clone().subtract(daysDiff, 'days')
      setValue({
        ...value,
        fromDate: momentToISOLocalDate(newFromMoment),
        toDate: newToDate
      })
    }
  }

  return (
    <ContainerColumn>
      <CompanyAutocompleteField
        onCompanySelected={handleCompanySelected}
        fieldName={`${name}.companyName`}
        label="form.order.cargo.companyName"
        disabled={disabled}/>
      <div className={styles.dateTimeFieldsContainer}>
        <DatePickerFormFieldInline
          onChange={handleFromDateSelected}
          name={`${name}.fromDate`}
          label={'form.order.cargo.fromDate'}
          datePickerClassName={classes.customHelperTextStyles}
          inputClassName={styles.dateTimeFieldInput}
          skipIcon
          notRequiredTouchedToError
          disabled={disabled}/>
        <div className={styles.dateTimeFieldsSeparator}/>
        <FieldComponent
          fieldName={`${name}.fromTime`}
          label={'form.order.cargo.fromTime'}
          skipErrorIcon
          className={styles.timeField}
          inputClassName={styles.dateTimeFieldInput}
          requireTouchToShowError={false}
          disabled={disabled}/>
        <div className={styles.dateTimeFieldsSeparator}/>
        <DatePickerFormFieldInline
          onChange={handleToDateSelected}
          name={`${name}.toDate`}
          label={'form.order.cargo.toDate'}
          datePickerClassName={classes.customHelperTextStyles}
          inputClassName={styles.dateTimeFieldInput}
          skipIcon
          disabled={disabled}/>
        <div className={styles.dateTimeFieldsSeparator}/>
        <FieldComponent
          fieldName={`${name}.toTime`}
          label={'form.order.cargo.toTime'}
          skipErrorIcon
          className={styles.timeField}
          inputClassName={styles.dateTimeFieldInput}
          disabled={disabled}/>
      </div>

      <FieldComponent
        fieldName={`${name}.address`}
        label={'form.order.cargo.address'}
        disabled={disabled}/>
      <FieldComponent
        required
        fieldName={`${name}.cityName`}
        label={'form.order.cargo.city'}
        disabled={disabled} />
      <ContainerRow>
        <CountrySelectField
          required
          name={`${name}.country`}
          label="form.order.cargo.country"
          className="w-100"
          disabled={disabled}/>
        <FieldComponent
          required
          fieldName={`${name}.zipCode`}
          label={'form.order.cargo.zipCode'}
          disabled={disabled}/>
      </ContainerRow>
    </ContainerColumn>
  )
}
